export enum SelfServeStepsIdentifiers {
  VenueDetails = 'venue-details',
  BusinessDetails = 'business-details',
  ProductList = 'product-list',
  ServicePricing = 'service-pricing',
}
